import { APIHandler, PreviewActionAPIError } from "utilities/apiHandler";

import {
    AddCommentResponse,
    ChannelReadResponse,
    DeleteCommentResponse,
    type ICommentFormValues,
    type INotifyPermissionRequest,
    type IUpdateCommentPermissionRequest,
    UpdateCommentPermissionResponse,
} from "commonComponents/entity/comment/CommentContainer/CommentContainer.api.types";

export interface ICommentHandler {
    addComment(linkedId: number, newComment: ICommentFormValues): Promise<AddCommentResponse>;
    deleteComment(id: number): Promise<DeleteCommentResponse>;
    notify(id: number, notifyOptions: INotifyPermissionRequest): Promise<AddCommentResponse>;
    updateCommentPermission(
        id: number,
        newPermissions: IUpdateCommentPermissionRequest,
    ): Promise<UpdateCommentPermissionResponse>;
    readComment(channelId: number): Promise<ChannelReadResponse>;
}

export class CommentHandler implements ICommentHandler {
    async addComment(
        linkedId: number,
        newComment: ICommentFormValues,
    ): Promise<AddCommentResponse> {
        return await APIHandler(`/api/comments/${linkedId}`, {
            method: "PUT",
            data: newComment,
            responseType: AddCommentResponse,
        });
    }

    async deleteComment(id: number): Promise<DeleteCommentResponse> {
        return await APIHandler(`/api/comments/${id}`, {
            method: "DELETE",
            responseType: DeleteCommentResponse,
        });
    }

    async notify(id: number, notifyOptions: INotifyPermissionRequest): Promise<AddCommentResponse> {
        return await APIHandler(`/api/comments/NotifyPermissionChange?id=${id}`, {
            method: "PUT",
            data: notifyOptions,
            responseType: AddCommentResponse,
        });
    }

    async updateCommentPermission(
        id: number,
        newPermissions: IUpdateCommentPermissionRequest,
    ): Promise<UpdateCommentPermissionResponse> {
        return await APIHandler(`/api/comments/Permissions?id=${id}`, {
            method: "PUT",
            data: newPermissions,
            responseType: UpdateCommentPermissionResponse,
        });
    }

    async readComment(channelId: number) {
        return await APIHandler(`/api/channels/${channelId}/read`, {
            method: "POST",
            responseType: ChannelReadResponse,
        });
    }
}

export class InlinePreviewCommentHandler implements ICommentHandler {
    async addComment(): Promise<AddCommentResponse> {
        throw new PreviewActionAPIError();
    }

    async deleteComment(): Promise<DeleteCommentResponse> {
        throw new PreviewActionAPIError();
    }

    async notify(): Promise<AddCommentResponse> {
        throw new PreviewActionAPIError();
    }

    async updateCommentPermission(): Promise<UpdateCommentPermissionResponse> {
        throw new PreviewActionAPIError();
    }

    async readComment(): Promise<ChannelReadResponse> {
        throw new PreviewActionAPIError();
    }
}
